import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import { ScopeServiceFragmentFragment } from "@/gql"

type ScopeSummaryProps = {
  service: ScopeServiceFragmentFragment
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScopeSummary',
  props: {
    service: null
  },
  setup(__props: any) {

const { service } = __props as {
  service: ScopeServiceFragmentFragment
}


const phases = computed(() => service.phases)

return { __sfc: true,phases }
}

})